// @ts-nocheck
/* eslint-disable */
export const appCopy16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="6" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5"/><path d="M10 6V3.5C10 2.67157 9.32843 2 8.5 2H3.5C2.67157 2 2 2.67157 2 3.5V8.5C2 9.32843 2.67157 10 3.5 10H6" stroke="currentColor" stroke-width="1.5"/></svg>`,
    name: 'copy-16' as const
};